/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS)Side Nav Geofence Events Icon component.
 */
export const SideNavGeofenceEventsIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x={3} y={3} width={18.5} height={18.5} rx={0.5} stroke={iconColor} strokeWidth={1.5}/>
      <path d="M8.97833 3.77368C9.17949 3.41159 9.04904 2.95499 8.68695 2.75383C8.32486 2.55267 7.86826 2.68312 7.6671 3.04521L8.97833 3.77368ZM2.69322 11.9982L2.32899 12.6538L3.64022 13.3823L4.00446 12.7266L2.69322 11.9982ZM4.00446 12.7266L8.97833 3.77368L7.6671 3.04521L2.69322 11.9982L4.00446 12.7266Z"
        fill={iconColor}/>
      <path d="M4.12244 20.8182L14.1732 3.40981"
        stroke={iconColor} strokeWidth={1.5}
        strokeLinecap="square"/>
      <path d="M9.7074 21.0922L20.059 3.16278"
        stroke={iconColor} strokeWidth={1.5}
        strokeLinecap="round"/>
      <path d="M15.395 21.1888L21.2547 11.0395"
        stroke={iconColor}
        strokeWidth={1.5}
        strokeLinecap="square"/>
    </svg>

  );
};
